import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { ConfigService } from '@ng-darwin/config';
import { AppConfigInterface, EndPointsInterface } from '../models/app-config.interface';
import { AggregatioRequestInterface, AggregationResponseInterface } from '../models/aggregation.interface';
import { lastValueFrom } from 'rxjs';

/**
 * @description Injectable
 * @class Psd2Service
 */
@Injectable({
  providedIn: 'root'
})
export class Psd2Service {

  private readonly _appConfig: AppConfigInterface = {};
  private readonly _endPoints: EndPointsInterface = {};
  private _consentCode = '';
  private _baseURL = '';

  /**
   * @description constructor
   * @param _http HttpClient
   * @param _configService ConfigService
   */
  constructor(
    private readonly _http: HttpClient,
    private readonly _configService: ConfigService,
  ) {
    this._appConfig = this._configService.config.app || {};
    this._endPoints = this._appConfig.endPoints || {};
    this._baseURL = (sessionStorage.getItem('app-unique-id') === this._configService.config.app['cdncApplication']
      ? this._appConfig.baseUrlCDNC
      : this._appConfig.baseUrl) as string;
    const consentCodeFromSessionStorage = sessionStorage.getItem('consentId');
    if (consentCodeFromSessionStorage) {
      this.setConsentCode(consentCodeFromSessionStorage);
    }
  }

  /**
   * @description postAggregation
   * @param request AggregatioRequestInterface
   * @returns Promise<AggregationResponseInterface>
   */
  postAggregation(request: AggregatioRequestInterface): Promise<AggregationResponseInterface> {
    const url = `${this._baseURL}/${this._endPoints.psd2}`;
    return lastValueFrom(this._http.post<AggregationResponseInterface>(url, request));
  }

  /**
   * @description postAggregationConsent
   * @param request AggregatioRequestInterface
   * @param consent string
   * @returns Promise<AggregationResponseInterface>
   */
  postAggregationConsent(request: AggregatioRequestInterface, consent: string): Promise<AggregationResponseInterface> {
    const url = `${this._baseURL}/${this._endPoints.psd2Consent}/${consent}`;
    return lastValueFrom(this._http.post<AggregationResponseInterface>(url, request));
  }

  /**
   * @description setConsentCode
   * @param value string
   */
  setConsentCode(value: string): void {
    this._consentCode = value;
  }

  /**
   * @description getConsentCode
   * @returns string
   */
  getConsentCode(): string {
    return this._consentCode;
  }
}
